module.exports = __webpack_public_path__ + "img/cost_centers.78303807.svg";